import { VueTypesConfig } from './types'

export const config: VueTypesConfig = {
  silent: false,
  logLevel: 'warn',
}
